<script setup lang="ts">
defineProps<{
  isLoading: boolean
}>()
</script>

<template>
  <div class="min-h-1">
    <UProgress v-if="isLoading" animation="carousel" size="xs" />
  </div>
</template>
